import React from 'react';
import { TrendingUp, Target, DollarSign } from 'lucide-react';
import { caseStudies } from '../mock';

const CaseStudies = () => {
  return (
    <section className="py-20 bg-[#0A0F0D]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Proven <span className="text-[#22C55E]">Results</span>
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-2xl mx-auto">
            Real campaigns. Real impact. Real ROI.
          </p>
        </div>

        <div className="space-y-8">
          {caseStudies.map((study, index) => (
            <div 
              key={study.id}
              className="bg-[#0F172A] border border-[#22C55E]/20 rounded-xl p-8 md:p-10 hover:border-[#22C55E]/50 transition-all duration-300 hover:shadow-lg hover:shadow-[#22C55E]/10 animate-fade-in-up"
              style={{ animationDelay: `${index * 200}ms` }}
            >
              <div className="flex flex-col md:flex-row items-start justify-between gap-8">
                {/* Campaign Info */}
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="px-4 py-1 bg-[#22C55E]/10 border border-[#22C55E]/30 rounded-full">
                      <span className="text-[#22C55E] font-semibold text-sm">{study.brand}</span>
                    </div>
                    <div className="flex items-center gap-2 text-[#94A3B8]">
                      <Target className="h-4 w-4" />
                      <span className="text-sm">{study.campaign}</span>
                    </div>
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-6">Campaign Performance</h3>
                  
                  {/* Before & After Grid */}
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
                    {/* Reach */}
                    <div>
                      <p className="text-[#94A3B8] text-sm mb-2 flex items-center gap-2">
                        <TrendingUp className="h-4 w-4" />
                        Reach
                      </p>
                      <div className="space-y-1">
                        <div className="flex items-baseline gap-2">
                          <span className="text-white/60 line-through text-lg">{study.before.reach}</span>
                        </div>
                        <div className="flex items-baseline gap-2">
                          <span className="text-[#22C55E] text-3xl font-bold">{study.after.reach}</span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Engagement */}
                    <div>
                      <p className="text-[#94A3B8] text-sm mb-2">Engagement Rate</p>
                      <div className="space-y-1">
                        <div className="flex items-baseline gap-2">
                          <span className="text-white/60 line-through text-lg">{study.before.engagement}</span>
                        </div>
                        <div className="flex items-baseline gap-2">
                          <span className="text-[#22C55E] text-3xl font-bold">{study.after.engagement}</span>
                        </div>
                      </div>
                    </div>
                    
                    {/* Conversions */}
                    <div>
                      <p className="text-[#94A3B8] text-sm mb-2">Conversions</p>
                      <div className="space-y-1">
                        <div className="flex items-baseline gap-2">
                          <span className="text-white/60 line-through text-lg">{study.before.conversions}</span>
                        </div>
                        <div className="flex items-baseline gap-2">
                          <span className="text-[#22C55E] text-3xl font-bold">{study.after.conversions}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* ROI Badge */}
                <div className="flex-shrink-0">
                  <div className="bg-gradient-to-br from-[#22C55E] to-[#16A34A] rounded-xl p-6 text-center shadow-lg shadow-[#22C55E]/30">
                    <DollarSign className="h-8 w-8 text-white mx-auto mb-2" />
                    <div className="text-4xl font-bold text-white mb-1">{study.roi}</div>
                    <div className="text-sm text-white/90 font-semibold">ROI Increase</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;